import { render, staticRenderFns } from "./PurchaseBlock.vue?vue&type=template&id=f678518c&scoped=true"
import script from "./PurchaseBlock.vue?vue&type=script&lang=js"
export * from "./PurchaseBlock.vue?vue&type=script&lang=js"
import style0 from "./PurchaseBlock.vue?vue&type=style&index=0&id=f678518c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f678518c",
  null
  
)

export default component.exports